var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{key:`load-${_vm.loadCount}`,attrs:{"id":"app"}},[_c('router-view'),_vm._v(" "),_c('cookie-consent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }